import React from "react";
import { Link } from "react-router-dom";
import Icon from "../Icon";
import { Item } from "semantic-ui-react";
import "./HLinkStrip.scss";
import PropTypes from "prop-types";

export const HLinkStrip = ({
  links,
  className = "",
  style = {},
  url,
}) => {
  return (
    <section className={`hireart-ds-link-strip ${className}`} style={style}>
      <div className="hireart-ds-link-strip-wrapper">
        <Item.Group className="hireart-ds-link-strip-content" unstackable>
          {links.map(({ title, description, url, image }) => (
            <Item as={url ? Link : "div"} to={url} key={title}>
              {image && <Item.Image size="tiny" src={image} />}
              <Item.Header>{title}</Item.Header>
              {description && (
                <Item.Description>
                  <div className="hireart-ds-link-strip-description">
                    {description}
                  </div>
                  {Boolean(url) && (
                    <div className="hireart-ds-link-strip-learn-more">
                      Learn more <Icon type="arrow_forward" size="md" />
                    </div>
                  )}
                </Item.Description>
              )}
            </Item>
          ))}
        </Item.Group>
      </div>
    </section>
  );
};

HLinkStrip.propTypes = {
  links: PropTypes.array,
};

